import { defineMessages, type IntlShape } from 'react-intl'
import { capitalise } from 'lib/string/stringUtils'

const voucherTypeMessages = defineMessages({
  printed: {
    id: 'MuLK0p6w-Os4rjQ-Nk7u',
    defaultMessage: 'Printed',
  },
  mixed: {
    id: 'TjlGNFiwE418yOMfDaBs',
    defaultMessage: 'Mixed',
  },
  digital: {
    id: 'vSMFgtyuQvBm-zfuc4r_',
    defaultMessage: 'Digital',
  },
})

function isKnownVoucherType(voucherType: string): voucherType is keyof typeof voucherTypeMessages {
  return voucherType in voucherTypeMessages
}

export function formatExperienceVoucherTypes(
  voucherTypes: Array<string>,
  intl: IntlShape,
): string {
  return intl.formatList(
    voucherTypes.map(voucherType => (
      isKnownVoucherType(voucherType)
        ? intl.formatMessage(voucherTypeMessages[voucherType], { count: voucherTypes.length })
        : capitalise(voucherType)
    )),
  )
}
